export const DESIGNS = [
  { id: "classic", name: "Classic", hint: "Timeless and safe for any role" },
  { id: "modern", name: "Modern", hint: "Centred header with a blue accent" },
  { id: "executive", name: "Executive", hint: "Traditional serif, suits senior roles" },
  { id: "compact", name: "Compact", hint: "Tighter spacing for long CVs" },
  { id: "minimal", name: "Minimal", hint: "Lots of white space, very clean" },
  { id: "skills_first", name: "Skills-first", hint: "Skills at the top, good for career changers" },
];

const STYLE = {
  classic: { font: "Inter, Arial, sans-serif", accent: "#0f766e", center: false, rule: "#d1d5db", size: 14, gap: 16 },
  modern: { font: "Inter, Arial, sans-serif", accent: "#1d4ed8", center: true, rule: "#1d4ed8", top: true, size: 14, gap: 16 },
  executive: { font: "Georgia, 'Times New Roman', serif", accent: "#14243b", center: true, rule: "#14243b", size: 14.5, gap: 18 },
  compact: { font: "Arial, sans-serif", accent: "#334155", center: false, rule: "#e2e8f0", size: 12.5, gap: 10 },
  minimal: { font: "Inter, Arial, sans-serif", accent: "#475569", center: false, rule: null, size: 14, gap: 24 },
  skills_first: { font: "Inter, Arial, sans-serif", accent: "#2563eb", center: false, rule: "#bfdbfe", size: 14, gap: 16, skillsFirst: true },
};

export default function CvPaper({ cv, design = "classic", photo }) {
  const s = STYLE[design] || STYLE.classic;
  const Section = ({ title, children }) => (
    <section style={{ marginTop: s.gap }}>
      <h2 style={{ color: s.accent, fontSize: s.size - 1, fontWeight: 700, letterSpacing: "0.06em", borderBottom: s.rule ? `1px solid ${s.rule}` : "none", paddingBottom: s.rule ? 4 : 0, marginBottom: 6 }}>{title}</h2>
      {children}
    </section>
  );
  const blocks = {
    summary: cv.summary && <Section key="summary" title="PROFESSIONAL SUMMARY"><p>{cv.summary}</p></Section>,
    skills: cv.skills?.length > 0 && <Section key="skills" title={s.skillsFirst ? "KEY SKILLS" : "CORE SKILLS"}><p>{cv.skills.join(" • ")}</p></Section>,
    experience: cv.experience?.length > 0 && (
      <Section key="experience" title="PROFESSIONAL EXPERIENCE">
        {cv.experience.map((e, i) => (
          <div key={i} style={{ marginBottom: s.gap * 0.6 }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
              <strong>{e.role} — {e.company}</strong><span style={{ color: "#4b5563", fontSize: s.size - 2 }}>{e.dates}</span>
            </div>
            <ul style={{ listStyle: "disc", marginLeft: 20, marginTop: 4 }}>{(e.bullets || []).map((b, j) => <li key={j} style={{ marginBottom: 2 }}>{b}</li>)}</ul>
          </div>
        ))}
      </Section>
    ),
    education: cv.education?.length > 0 && <Section key="education" title="EDUCATION">{cv.education.map((ed, i) => <p key={i}><strong>{ed.degree}</strong>, {ed.institution} {ed.dates && `(${ed.dates})`}</p>)}</Section>,
    certifications: cv.certifications?.length > 0 && <Section key="certifications" title="CERTIFICATIONS"><p>{cv.certifications.join(" • ")}</p></Section>,
  };
  const order = s.skillsFirst ? ["skills", "summary", "experience", "education", "certifications"] : ["summary", "skills", "experience", "education", "certifications"];
  const contact = [cv.contact?.email, cv.contact?.phone, cv.contact?.location, cv.contact?.linkedin].filter(Boolean).join("  |  ");
  return (
    <div data-testid="cv-preview-paper" data-design={design} className="bg-white rounded-xl border border-line shadow-card overflow-y-auto max-h-[640px]"
      style={{ fontFamily: s.font, fontSize: s.size, lineHeight: 1.5, color: "#111827", padding: design === "compact" ? "24px 26px" : design === "minimal" ? "40px 44px" : "32px 34px" }}>
      <header style={{ textAlign: s.center && !photo ? "center" : "left", borderBottom: s.top ? `2px solid ${s.rule}` : "none", paddingBottom: s.top ? 10 : 0, display: photo ? "flex" : "block", gap: 16, alignItems: "flex-start", justifyContent: "space-between" }}>
        <div style={{ minWidth: 0 }}>
          <h1 style={{ fontSize: design === "compact" ? 22 : 26, fontWeight: 700, lineHeight: 1.2 }}>{cv.name}</h1>
          {cv.title && <p style={{ color: s.accent, fontWeight: 500 }}>{cv.title}</p>}
          {contact && <p style={{ color: "#4b5563", fontSize: s.size - 2, marginTop: 2 }}>{contact}</p>}
        </div>
        {photo && <img src={photo} alt="" data-testid="cv-preview-photo" style={{ width: 84, height: 84, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />}
      </header>
      {order.map((k) => blocks[k])}
    </div>
  );
}
